export enum CommandType {
  NORMAL = "NORMAL",
  BLOCK = "BLOCK",
  UNBLOCK = "UNBLOCK"
}
